module.exports = __webpack_public_path__ + "static/media/bachelor-degree.70593492.png";